/**
 * 何かあった時にWeglotを無効化するできるように残す.
 * TODO: 問題なさそうなら削除する
 */
export const enableWeglot = (): boolean => {
  return true;
};
